// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoComponent_wrapper__2AxJc","textWrapper":"VideoComponent_textWrapper__ETRsi","iframe":"VideoComponent_iframe__g0lpf"};